import mixin from '../../mixins/Mixin.js';
import state from '../../store/modules/grapes-data';
export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var modal = null;
  var self;

  var players = [];
  var page = 0;
  var total_number = 1;
  var initialise = false;
  domc.addType('player', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'player',
          tagName: 'div',
          src: '',
          width: '100%',
          height: '100%',
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'autoplay',
              name: 'autoplay',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'loop',
              name: 'loop',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'controls',
              name: 'controls',
              changeProp: 1,
            },
          ],
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
          this.listenTo(this, 'change:autoplay', this.updateUrlVid);
          this.listenTo(this, 'change:loop', this.updateUrlVid);
          this.listenTo(this, 'change:controls', this.updateUrlVid);
        },
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') == 'player'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          this.view.el.setAttribute('src', this.get('src'));
          this.view.el.setAttribute('data-thumbnail', this.get('thumbnail'));
          this.view.getIframe().src = this.get('src');
          this.updateAutoplay();
          this.updateLoop();
          this.updateControl();
        },
        updateAutoplay() {
          this.updateUrlVid(this.get('autoplay'), 'a', 1);
        },
        updateLoop() {
          this.updateUrlVid(this.get('loop'), 'loop', 1);
        },
        updateControl() {
          this.updateUrlVid(this.get('controls'), 'sc', 1);
        },
        updateUrlVid() {
          let url = this.get('src').split('?')[0] + '?';
          const params = [
            { name: 'autoplay', value: 'a' },
            { name: 'loop', value: 'loop' },
            { name: 'controls', value: 'sc' },
          ];

          url += params.map(param => param.value + '=' + (this.get(param.name) ? 1 : 0)).join('&');

          this.view.el.setAttribute('src', url);
          this.set('src', url);
          this.view.getIframe().src = url;
        },
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'player', src: el.src };
          }
          return result;
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'player', src: el.src };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      events: {
        click: 'updateSrcField',
        dblclick: 'openModal',
      },
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        modal = editor.Modal;
        modal.setTitle(config.translate.select_new);
      },
      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'player-' + mixin.methods.makeId();
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style = 'border:none;overflow:hidden';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';

        self.openModal();
      },
      noVideos() {
        modal.setContent(`<div id="modal-players-list" class="container" style=" min-height: 100px;padding:5px;display: inline-block;max-height: 660px; overflow-y: auto">
                                        <span><img src="
                    static/images/nofound.png" alt="nofound image"></span>
                                   </div>`);
      },
      reloadPlayersList() {
        var titleVideo = document.getElementById('myInput');
        var noVideo = document.getElementById('noVideo');
        if (noVideo != null) {
          noVideo.style.display = 'none';
        }

        page = page + 1;
        var modalContent = document.getElementById('modal-players-list');
        if (titleVideo.value !== '') {
          page = 1;
        }
        self.showLoader();
        config
          .http(window.ApiToken)
          .get(
            config.routing.generate(config.api_routing, {
              id: '',
              page: page,
              nbParPage: 20,
              client: config.client.paramsClient.client,
              searchWord: titleVideo.value,
              maxBitrate: true,
            }),
          )
          .then(
            function(response) {
              self.hideLoader();
              if (response.data.code === 200) {
                var selected = 0;
                total_number = response.data.nombre_total;
                document.querySelector('.gjs-mdl-dialog.gjs-one-bg.gjs-two-color').style.display =
                  'block';
                if (response.data.medias.length === 0 && players.length === 0) {
                  self.noVideos();
                } else if (response.data.medias.length === 0 && titleVideo.value !== '') {
                  modalContent.innerHTML = '';
                  var element = document.createElement('div');
                  element.className = 'no-found-video';
                  element.id = 'noVideo';
                  element.innerHTML =
                    `<img src="` +
                    'static/images/nofound.png' +
                    `" alt="nofound image">
                         `;
                  modalContent.appendChild(element);
                } else {
                  if (titleVideo.value !== '') {
                    modalContent.innerHTML = '';
                  }
                  response.data.medias.forEach(val => {
                    var element = document.createElement('div');
                    element.setAttribute('data-duration', val.duration);
                    element.id = 'i' + val.id;
                    element.className = 'player-item';
                    var srcImage;
                    if (val.logo && val.logo !== '') {
                      srcImage = val.logo;
                    } else {
                      srcImage = '/static/images/vignette.jpg';
                    }
                    element.innerHTML =
                      `<img src="` +
                      srcImage +
                      `" alt="Card image">
                          <div class="vidPlayer">
                               <h5 class="descriptionPlayer" title="` +
                      val.title +
                      `">` +
                      val.title +
                      `</h5>
                                        </div>`;
                    modalContent.appendChild(element);
                  });
                  response.data.medias.forEach(val => {
                    const el = document.getElementById('i' + val.id);

                    el.addEventListener('click', function() {
                      if (selected !== 0) {
                        document.getElementById('i' + selected).classList.remove('selected');
                      }

                      selected = val.id;
                      document.getElementById('i' + val.id).classList.add('selected');

                      var selectedElement = grapesjsEMP.editors[0].getSelected();
                      if (selectedElement !== undefined) {
                        try {
                          let iframe = grapesjsEMP.editors[0]
                            .getSelected()
                            .view.el.querySelector('iframe');
                          iframe.setAttribute('src', val.lien);
                          iframe.setAttribute('data-thumbnail', val.thumbnail);
                        } catch (e) {}
                        self.model.set('duration', val.duration);
                        grapesjsEMP.editors[0].getSelected().set('src', val.lien);
                      } else {
                        self.model.set('duration', val.duration);
                        self.getIframe().src = val.lien;
                        self.model.set('src', val.lien);
                        self.getIframe().setAttribute('duration', val.duration);
                        self.model.set('thumbnail', val.logo);
                      }
                      self.model.updateUrlVid();
                    });
                    el.addEventListener('dblclick', function() {
                      document.querySelector('.gjs-mdl-btn-close').click();
                    });
                  });

                  players = players.concat(response.data.medias);
                  if (players.length === total_number) {
                    document
                      .getElementById('modal-players-container')
                      .removeEventListener('scroll', function() {
                        var listElm = document.getElementById('modal-players-container');
                        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                          self.reloadPlayersList();
                        }
                      });
                    self.hideLoader();
                  } else {
                    if (!initialise) {
                      document
                        .getElementById('modal-players-container')
                        .addEventListener('scroll', function() {
                          var listElm = document.getElementById('modal-players-container');
                          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                            self.reloadPlayersList();
                          }
                        });
                      initialise = true;
                    }
                  }
                }
              }
            },
            function(response) {
              self.hideLoader();
            },
          );
      },

      hideLoader() {
        document.getElementById('loader-list').style.visibility = 'hidden';
      },
      showLoader() {
        document.getElementById('loader-list').style.visibility = 'visible';
      },
      onScroll() {
        var listElm = document.getElementById('modal-players-container');
        var titleVideo = document.getElementById('myInput');

        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          self.reloadPlayersList();
        }
      },
      openModal() {
        page = 0;
        players = [];
        initialise = false;
        modal.setContent(`<div id="modal-players-container" class="players-list">
                            <div id="search-list" class="search-wrapper">
                                      <input type="text" id="myInput"  placeholder="..."  />
                                    </div>
                                       <div id="modal-players-list" class="players-wrapper"></div>
                                       <div id="loader-list" class="loader-4 center"><span></span></div>
                                   </div>`);

        self.reloadPlayersList();
        modal.open();
        var titleVideo = document.getElementById('myInput');
        var configMixin = mixin.methods.getLangCode('display-player-plugin');
        if (titleVideo) titleVideo.placeholder = configMixin.translate.placeholder;
        modal.getModel().once('change:open', function() {
          document.getElementById('CanvOverlay').style.display = 'none';

          const getAllComponents = (model, result = []) => {
            result.push(model);
            model.components().each(mod => getAllComponents(mod, result));
            return result;
          };
          const all = getAllComponents(editor.DomComponents.getWrapper());

          for (var i = 0; i < all.length; i++) {
            let type = all[i].attributes.type;
            let src = all[i].attributes.src;
            if (type === 'player' || type === 'playlist' || type === 'live') {
              if (!src) {
                grapesjsEMP.editors[0].UndoManager.undo();
              }
            }
          }
        });

        var textInput = document.getElementById('myInput');
        textInput.addEventListener('input', self.reloadPlayersList);
      },
      updateSrcField() {
        const src = this.model.get('src') || this.el.getAttribute('src') || this.getIframe().src;
        const duration =
          this.model.get('duration') ||
          this.el.getAttribute('duration') ||
          this.getIframe().getAttribute('duration');
        this.model.set('src', src);
        this.model.set('duration', duration);

        const thumbnail = this.model.get('thumbnail') || this.el.getAttribute('data-thumbnail');
        this.model.set('thumbnail', thumbnail);
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/player/components.js